export const ACCOUNT_STATEMENTS_PAGINATED = gql`
    query getAccountStatementsPaginated($filters: AccountStatementsTableFiltersInput) {
        getAccountStatementsPaginated(filters: $filters) {
            data {
                id
                accountStatementId
                statementDate
                outstandingBalance
                merchant {
                    accountNumber
                    tradingName
                    currencySymbol
                }
            }
            page
            pageSize
            total
        }
    }
`;
